/*
 * Used to convert 20px to int 20
 * Usually used together with theme
*/

export function useSize(value) {
  return parseInt(value.replace(/rem|em|vh|vw|vmin|vmax|ex|%|px|cm|mm|in|pt|pc|ch/g, ''));
}
